import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/hooks/useAuth";
import { ProtectedRoute, AdminRoute } from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import ExchangeConnection from "@/pages/ExchangeConnection";
import BotSettings from "@/pages/BotSettings";
import EntryRules from "@/pages/EntryRules";
import ExitRules from "@/pages/ExitRules";
import OpenPositions from "@/pages/OpenPositions";
import TradeHistory from "@/pages/TradeHistory";
import SignalLogs from "@/pages/SignalLogs";
import SignalValidation from "@/pages/SignalValidation";
import StrategyProfiles from "@/pages/StrategyProfiles";
import BacktestV2 from "@/pages/BacktestV2";
import RiskSettings from "@/pages/RiskSettings";
import Backtest from "@/pages/Backtest";
import CompareBacktests from "@/pages/CompareBacktests";
import WalkForward from "@/pages/WalkForward";
import AdminPanel from "@/pages/AdminPanel";
import StrategyTrades from "@/pages/StrategyTrades";
import StrategySlots from "@/pages/StrategySlots";

function App() {
  return (
    <div className="App dark">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="/exchange" element={<ExchangeConnection />} />
              <Route path="/settings" element={<BotSettings />} />
              <Route path="/entry-rules" element={<EntryRules />} />
              <Route path="/exit-rules" element={<ExitRules />} />
              <Route path="/positions" element={<OpenPositions />} />
              <Route path="/history" element={<TradeHistory />} />
              <Route path="/strategy-trades" element={<StrategyTrades />} />
              <Route path="/signals" element={<SignalLogs />} />
              <Route path="/validation" element={<SignalValidation />} />
              <Route path="/strategies" element={<StrategyProfiles />} />
              <Route path="/strategy-slots" element={<StrategySlots />} />
              <Route path="/backtest-v2" element={<BacktestV2 />} />
              <Route path="/backtest" element={<Backtest />} />
              <Route path="/compare" element={<CompareBacktests />} />
              <Route path="/walkforward" element={<WalkForward />} />
              <Route path="/admin" element={<AdminRoute><AdminPanel /></AdminRoute>} />
              <Route path="/risk" element={<RiskSettings />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
